export const START_ROUTE = '/start'
export const LOGIN_ROUTE = '/login'
export const LOAD_ROUTE = '/loading'
export const HOME_ROUTE = '/'
export const CARD_CONTRACT_ROUTE = '/contract/:id'
export const CARD_QUOTA_ROUTE = '/quota/:id'
export const CARD_NETWORK_ROUTE = '/network/:id'
export const ACCOUNT_ROUTE = '/account'
export const ADD_STUDENT_ROUTE = '/createStudent'
export const AGENT_LIST = '/agents'
export const EMAIL_LIST = '/emails'
export const STATS = '/stats'

// Электронный журнал
export const JOURNAL_GROUPS = '/journal'
export const JOURNAL_GROUP_ROUTE = '/journal/groups/:id'
export const JOURNAL_SHEET_ROUTE = '/journal/groups/:id/sheet'
export const JOURNAL_WORKLOAD = '/journal/workload'

export const journalGroupLink = (id) => `/journal/groups/${id}`
export const journalSheetLink = (id) => `/journal/groups/${id}/sheet`

export const internalServerError = (e) => {
    return e.response.status === 500 ? 'Ошибка сервера, попробуйте снова' : e.response.data.message
}
